

















































































































































































import formatDate from "@/helpers/formatDate";
import { saveServiceTask } from "@/servicetask/api/service-tasks-api";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import OperatorSelect from "../../../components/OperatorSelect.vue";
export interface ServiceTaskFormData {
  id?: number;
  status: string;
  pending: boolean;
  startDate: string;
  endDate: string;
  staff: string;
  memo: string;
  memoEmphasized: boolean;
  otherTasks: {
    id: number;
    shortName: string;
    date: string; // yyyy-MM-dd
  }[];
  constructionTasks: {
    id: number;
    shortName: string;
    status: "done" | "pending";
  }[];
}

@Component({
  components: {
    OperatorSelect
  }
})
export default class ServiceTaskForm extends Vue {
  @Prop({ required: true }) projectId!: number;
  @Prop({ type: Object }) defaultValues?: ServiceTaskFormData;
  @Prop({ required: true }) taskTypeId!: number;

  @Watch("defaultValues", { immediate: true })
  updateValues(defaultValues: ServiceTaskFormData) {
    if (!defaultValues) {
      return;
    }
    this.data = defaultValues;
  }

  get onMobile() {
    return this.$store.getters.onMobile;
  }

  data: ServiceTaskFormData = {
    status: "",
    pending: false,
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
    staff: "",
    memo: "",
    memoEmphasized: false,
    otherTasks: [],
    constructionTasks: []
  };

  pendingOptions = [
    {
      text: "着工",
      value: false
    },
    {
      text: "保留",
      value: true
    }
  ];

  public async submit() {
    try {
      await saveServiceTask(this.data);
    } catch (e) {
      alert(e);
      throw e;
    }
    this.$emit("submit");
  }
}
